<template>
    <div class="px-3">
        <div aria-describedby="descriptionHelp">
            <address-component
                :address="address"
                :isAddressDetails="details"
                :class="model.fieldCode"
                :profile-data="profileData"/>
        </div>
        <small id="descriptionHelp" class="form-text text-muted">{{ isEnVersion ? model.descriptionEn : model.description }}</small>
    </div>
</template>

<script>
    import AddressComponent from '../address/Address';
    import { Address, DynamicRegisterAddressModel, EditorComponentModel } from '../../models/models';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            model: {
                type: EditorComponentModel
            },
            details: {
                type: Boolean,
                default: false
            },
            allowAnonymous: {
                type: Boolean,
                default: true
            },
            profileData: {
                type: Object,
                default() {
                    return null;
                }
            },
            isEvaluationPanel: {
                type: Boolean,
                default: false
            }
        },
        components: {
            AddressComponent,
        },
        data() {
            return {
                address: new Address()
            }
        },
        mounted () {
            this.$parent.$parent.addresses.push(new DynamicRegisterAddressModel({
                fieldId: this.model.id,
                address: this.address
            }));

            this.model.uid = this._uid;
            this.model.isEvaluationPanel = this.isEvaluationPanel;
        },
        computed: {
            ...mapGetters(['isEnVersion']),
        }
    }
</script>
